export const isValidEori = (eori: string) => {
  const regex = /^FR\s*\d{3}\s*\s*\d{3}\s*\d{3}\s*(\d{5})?$/g;
  return regex.test(eori);
};
